import { Accordion, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const FAQs = () => (
  <Container style={{ marginTop: "2rem" }}>
    <p>
      If you haven't watched our Youtube tutorials, you can find the playlist{" "}
      <a href="https://www.youtube.com/playlist?list=PL_py24H3UDPuBuQlG4gdJxznmoHayc_BI">
        here
      </a>
      .
    </p>
    <p>
      For help getting started, specifically check out our{" "}
      <a href="https://www.youtube.com/watch?v=Z763ud7POkE&list=PL_py24H3UDPuBuQlG4gdJxznmoHayc_BI&index=1&ab_channel=StubMiner">
        Getting Started Pt 1
      </a>{" "}
      and{" "}
      <a href="https://www.youtube.com/watch?v=LPtHxGBDPyw&list=PL_py24H3UDPuBuQlG4gdJxznmoHayc_BI&index=2&ab_channel=StubMiner">
        Getting Started Pt 2
      </a>{" "}
      videos.
    </p>
    <Accordion flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <h3>Can I run this on an iOS device?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>No, we only support Android devices at this time.</p>
          <p>
            If you don't have an Android phone, you can order one from us on our{" "}
            <Link to="/purchase">Purchase</Link> page.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <h3>What is the affiliate program?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            When you sign up, you are assigned an affiliate ID. If someone else
            signs up for Stubminer and enters your affiliate ID, every time they
            spend money, you get credited with 10% of whatever they spend. So be
            sure to tell your friends to enter your affiliate ID when they sign
            up!
          </p>
          <p>
            You can find your affiliate code on your account page by clicking{" "}
            <Link to="/account">here</Link>, or by clicking on your email
            address in the top right of the page. There is a "share" button that
            will copy a signup link with your affiliate code to your clipboard.
          </p>
          <p>
            If you receive credit through the affiliate program, you will
            receive an email, telling you how much you earned. You can also see
            your balance on the account page by clicking{" "}
            <Link to="/account">here</Link>, or by clicking on your email
            address in the top right of the page.
          </p>
          <p>
            You can apply your balance to your next subscription payment. You
            don't need to do anything to apply your balance to your next
            payment. It will be automatically applied.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>
          <h3>Can I run Stubminer "in the background" on my phone?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            No. In order for Stubminer to work, it needs to have uninterrupted
            access to your phone so that it can perform the actions it needs to
            in the Show companion app.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>
          <h3>Why isn't Stubminer placing bids?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            If you aren't seeing buy orders placed for players, check the
            settings in the web app. These settings are applied to all of the
            cards you're currently mining, so make sure things like maximum bid
            are set to accommodate the players you're targeting in your
            watchlist.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4">
        <Accordion.Header>
          <h3>How do I select which cards to use for mining stubs?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            Simply click the "heart" icon in the Show companion app to add a
            card to your watch list. Stubminer will use the first 3 player
            cards.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header>
          <h3>Can I mine more than 3 players at a time?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>No, the limit is 3 players per account.</p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header>
          <h3>Can I mine with non-player cards, like equipment or stadiums?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            Yep! Just select the correct card type when you start up the
            scripts.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="7">
        <Accordion.Header>
          <h3>How can I find the best cards to use?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            We recommend using{" "}
            <a href="https://showzone.gg/" target="_new">
              ShowZone
            </a>{" "}
            for finding the best cards for flipping.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="8">
        <Accordion.Header>
          <h3>Can I run Stubminer on multiple devices at one time?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            Stubminer is limited to running on one device per-account at one
            time. If you want to switch Stubminer to a new device, you'll need
            to click the 'Reset Device ID' button on the Stubminer website's
            Settings page.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="9">
        <Accordion.Header>
          <h3>How long can Stubminer run before I need to restart it?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            We recommend stopping Stubminer every 6-8 hours and clearing the
            Automate flow logs. This can be done by opening Automate, selecting
            each flow, and tapping the file icon in the top right of the screen.
          </p>
          <p>
            A dropdown appears with the options Logging, View, Send, and Clear.
            Select Clear for each flow, and then restart Stubminer by launching
            the Main flow and entering your username and password.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="10">
        <Accordion.Header>
          <h3>I'm seeing an error in the flow logs. What should I do?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            A great general-purpose debugging tool is to “reset” Stubminer by
            running the Reset Stubminer flow in Automate. After you've done so,
            you'll need to re-run flows 1, 2, and 3 to re-initialize them. Once
            you've done so, you can restart Stubminer by running flow 0 and
            entering your username and password.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="11">
        <Accordion.Header>
          <h3>How do I get Stubminer to stop running?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            You can interrupt Stubminer and stop its execution by pressing the
            home button on your device several times. You can also quit the
            Automate app to stop Stubminer.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="12">
        <Accordion.Header>
          <h3>
            I'm getting an error about the DeviceId not matching. What should I
            do?
          </h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            If you see this error, you need to click the 'Reset Device ID'
            button on the Stubminer website's Settings page.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="13">
        <Accordion.Header>
          <h3>
            I just paid for a subscription, but it still says I don't have a
            subscription. What gives?
          </h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            It can take up to 2 minutes for the payment to process. Refresh your
            account page periodically to see if it has updated. If it still
            isn't showing up, email us at{" "}
            <a href="mailto:contact@stubminer.com">contact@stubminer.com</a>.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="14">
        <Accordion.Header>
          <h3>Can I get banned for using Stubminer?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            Stubminer is carefully calibrated to mimic how a person would
            interact with the app, making it difficult to discern that the
            activity is automated. That said, this is a use-at-your-own-risk
            product. We do not guarantee that you will not receive a ban.
          </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="15">
        <Accordion.Header>
          <h3>How do I get a signup credit?</h3>
        </Accordion.Header>
        <Accordion.Body>
          <p>
            To get the $5 signup credit, you need to register using a referral
            code from another user. When you do, you'll receive a $5 credit on
            your account after creating your first subscription (of any tier).
          </p>
          <p>
            The credit is automatically applied to your next purchase or payment
            in the app. You don't have to do anything to apply the credit
            manually.
          </p>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  </Container>
);

export default FAQs;
